import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { SIMULATED_IWOS_MESSAGES, parseIWOSRawMessage } from '../../utils/simulated-data';
import './SimulatedDataSelector.scss';

const SimulatedDataSelector = ({ onDataSelected, showRawMessage = true }) => {
  const [selectedId, setSelectedId] = useState('');
  const [rawExpanded, setRawExpanded] = useState(false);

  const handleSelectionChange = (e) => {
    const id = e.target.value;
    setSelectedId(id);

    if (id) {
      const message = SIMULATED_IWOS_MESSAGES.find(m => m.id === id);
      const parsed = parseIWOSRawMessage(message.raw);

      if (onDataSelected) {
        onDataSelected(parsed, message);
      }
    } else {
      if (onDataSelected) {
        onDataSelected(null, null);
      }
    }
  };

  const selectedMessage = SIMULATED_IWOS_MESSAGES.find(m => m.id === selectedId);

  return (
    <div className="simulated-data-selector">
      <div className="selector-header">
        <label htmlFor="simulated-message-select">
          <strong>Simulated IWOS Message:</strong>
        </label>
        <select
          id="simulated-message-select"
          value={selectedId}
          onChange={handleSelectionChange}
          className="message-select"
        >
          <option value="">-- Select a test scenario --</option>
          {SIMULATED_IWOS_MESSAGES.map(msg => (
            <option key={msg.id} value={msg.id}>
              {msg.name} ({msg.timestamp})
            </option>
          ))}
        </select>
      </div>

      {selectedMessage && (
        <div className="selected-info">
          <p className="description">{selectedMessage.description}</p>
        </div>
      )}

      {showRawMessage && selectedMessage && (
        <div className="raw-message-section">
          <button
            type="button"
            className="raw-toggle"
            onClick={() => setRawExpanded(!rawExpanded)}
          >
            {rawExpanded ? '[-]' : '[+]'} Raw IWOS Message
          </button>
          {rawExpanded && (
            <pre className="raw-message">{selectedMessage.raw}</pre>
          )}
        </div>
      )}
    </div>
  );
};

SimulatedDataSelector.propTypes = {
  onDataSelected: PropTypes.func,
  showRawMessage: PropTypes.bool,
};

export default SimulatedDataSelector;
